import { Ref, unref, reactive } from 'vue';
import { useVuelidate, ValidationArgs } from '@vuelidate/core';
import { BaseFormModel } from 'Models';

// TODO:
// 1. Ability to set if field need to validate if it not required (for example, if field is hidden but there is address2 which is not required)
// 2. Rename to useValidation or useValidationForm

export function useFormValidation(rules: ValidationArgs, model: BaseFormModel | Ref<BaseFormModel>) {
  const rawModel = unref(model);
  return useVuelidate(rules, reactive(rawModel.data));
}
